import React from "react";

export default function AuctionSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="57"
      height="57"
      fill="none"
      viewBox="0 0 57 57"
    >
      <circle
        cx="28.5"
        cy="28.5"
        r="28.5"
        fill="#4176DE"
        fillOpacity="0.24"
      ></circle>
      <circle
        cx="28.5"
        cy="28.5"
        r="27"
        stroke="#CBDCFF"
        strokeWidth="3"
      ></circle>
      <circle
        cx="28.5"
        cy="28.5"
        r="27"
        stroke="#CBDCFF"
        strokeWidth="3"
      ></circle>
      <circle cx="28.5" cy="28.5" r="20.5" fill="#1C64F2"></circle>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M28.881 19.367l-1.367 1.368.237.236.237.237-2.389 2.389-2.388 2.388-.238-.235-.238-.235-1.356 1.355c-.745.745-1.356 1.374-1.356 1.398 0 .024 1.53 1.574 3.401 3.444l3.402 3.401 1.377-1.377 1.377-1.376-.224-.227-.225-.227.343-.345.343-.344.84.84.842.84.192-.194.192-.196 2.756 2.756c1.516 1.516 2.776 2.757 2.8 2.757.023 0 .619-.577 1.323-1.281l1.28-1.281-2.775-2.776-2.777-2.776.203-.206.203-.206-.838-.839-.838-.838.343-.345.343-.344.227.225.228.225 1.367-1.366 1.366-1.366-3.423-3.423L30.248 18l-1.367 1.367zm3.907 2.982l2.497 2.496-.463.463-.462.463-2.508-2.507-2.507-2.508.451-.452a7.12 7.12 0 01.473-.452c.013 0 1.146 1.123 2.52 2.497zm-1.84 1.819l2.034 2.034-2.39 2.39-2.389 2.388-2.045-2.044-2.045-2.045 2.379-2.379c1.308-1.308 2.388-2.379 2.4-2.379.012 0 .937.916 2.056 2.035zm-5.694 5.714l2.496 2.497-.45.453-.452.453-2.508-2.508-2.508-2.508.44-.442a6.79 6.79 0 01.463-.441c.012 0 1.146 1.123 2.519 2.496zm7.427-.752l.365.366-.785.785-.785.785-.377-.376-.376-.377.774-.775c.426-.426.784-.775.797-.775.013 0 .187.165.387.367zm3.228 4.003l2.303 2.303-.386.388-.387.388-2.314-2.314-2.314-2.314.375-.377a5 5 0 01.398-.377c.013 0 1.059 1.036 2.325 2.303zM18 38.106V40h11.667V36.211H18v1.895zm10.376 0v.602h-9.084v-1.205h9.084v.603z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
